import { QueryHandler } from '@/redux/types/query-handler';
import { dispatchOptimisticPatchUpdateAccessibilitySettings } from './dispatch-optimistic-patch';
import { UpdateAccessibilitySettingsQueryArg } from '../types/query-arg';

export const handleResultUpdateAccessibilitySettings: QueryHandler<
  UpdateAccessibilitySettingsQueryArg,
  void
> = async (queryArg, { dispatch, getState, queryFulfilled }) => {
  const { patch } = dispatchOptimisticPatchUpdateAccessibilitySettings(
    queryArg,
    {
      dispatch,
      getState,
    },
  );

  try {
    await queryFulfilled;
  } catch (err) {
    patch.undo();
    throw err;
  }
};
